import { AppUserRole, UserGroup } from '@repo/validation';

const ROLE_BY_GROUP: Record<UserGroup, AppUserRole> = {
  [UserGroup.Owners]: AppUserRole.Owner,
  [UserGroup.Admins]: AppUserRole.Admin,
  [UserGroup.Managers]: AppUserRole.Manager,
  [UserGroup.Teachers]: AppUserRole.Teacher,
  [UserGroup.Students]: AppUserRole.Student,
  [UserGroup.BillingOfficers]: AppUserRole.BillingOfficer,
  [UserGroup.PayrollOfficers]: AppUserRole.PayrollOfficer,
  [UserGroup.ShiftManagers]: AppUserRole.ShiftManager,
  [UserGroup.CourseManagers]: AppUserRole.CourseManager,
  [UserGroup.CourseDevelopers]: AppUserRole.CourseDeveloper,
};

/**
 * The roles a caller's Cognito groups give them: one role per group, with no
 * hierarchy, so an Owner in every staff group holds every staff role. An
 * unknown group gives nothing.
 */
export const appUserRolesForGroups = (groups: readonly UserGroup[]): AppUserRole[] => [
  ...new Set(
    groups
      .map(group => ROLE_BY_GROUP[group])
      .filter((role): role is AppUserRole => role !== undefined)
  ),
];
